export const COMPANY_NAME = '컴활의 정석';
export const HOMEPAGE_TITLE = '컴활의 정석 관리자';
